import React, { MouseEvent } from "react";

export interface CoverallProps {
	onClick?: (evt: React.MouseEvent<HTMLDivElement>) => void;
	show?: boolean;
}

const Coverall: React.FC<CoverallProps> = ({ show = false, onClick = () => null }) => {
	return <div className={`coverall blur-bg ${show ? "active" : ""}`} onClick={onClick}></div>;
};

export default Coverall;
